import React from "react";
import { useNavigate } from "react-router-dom";
import "./FailedPage.css";

const FailedPage = () => {
  const navigate = useNavigate();

  const handleContactSupport = () => {
    window.open("https://www.lagran.in/contactUS", "_blank");
  };

  return (
    <div className="failed-container">
      <div className="failed-card">
        <div className="failed-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 16 16"
          >
            <circle cx="8" cy="8" r="8" fill="red" />
            <path
              fill="white"
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
        <h2 className="failed-title">Payment Failed!</h2>
        <p className="failed-message">
          Unfortunately, your payment could not be processed. Please try again
          or reach out to our support team.
        </p>

        <div className="support-info">
          <p>
            <strong>Need Help?</strong>
          </p>
          <p>
            📞 <strong>Phone:</strong>{" "}
            <a href="tel:+919876543210">+91 8978465525</a>
          </p>
          <p>
            📧 <strong>Email:</strong>{" "}
            <a href="mailto:info@lagran.in">info@lagran.in</a>
          </p>
        </div>

        <button className="contact-button" onClick={handleContactSupport}>
          Contact Us
        </button>
      </div>
    </div>
  );
};

export default FailedPage;
